import CAROUSEL from './i18n/carousel.en.json';
import COMMON from './i18n/common.en.json';
import GOUVERNANCE from './i18n/gouvernance.en.json';
import HEADER from './i18n/header.en.json';
import SOCIAL from './i18n/social.en.json';
import FOOTER from './i18n/footer.en.json';
import PRESS_AREA from './i18n/press-area.en.json';
import ERROR from './i18n/error.en.json';
import HOME from './i18n/home.en.json';
import ICON from './i18n/icon.en.json';
import SHORTCUTS from './i18n/shortcuts.en.json';
import MEDIA from './i18n/media.en.json';
import MEDIA_THEMATIC from './i18n/media-thematic.en.json';
import BRANCHES from './i18n/branches.en.json';
import FINANCIAL from './i18n/financial.en.json';
import CATEGORIES from './i18n/categories.en.json';
import TERRITORIES from './i18n/territories.en.json';
import THEMATICS from './i18n/thematics.en.json';
import TYPES from './i18n/types.en.json';
import AGENDA from './i18n/agenda.en.json';
import FILTERS from './i18n/filters.en.json';
import EXPERTISES from './i18n/expertises.en.json';
import INNOVATIONS from './i18n/innovations.en.json';
import CONTACTS from './i18n/contacts.en.json';
import SEARCH from './i18n/search.en.json';
import RGPD from './i18n/RGPD.en.json';
import DATA_NOVA_MAP from './i18n/data-nova-map.en.json';
import PAGINATION from './i18n/pagination.en.json';
import PUBLICATION from './i18n/publication.en.json';
import HUB_ACTUS from './i18n/hub-actualites.en.json';

export {
  CAROUSEL,
  COMMON,
  GOUVERNANCE,
  HEADER,
  SOCIAL,
  FOOTER,
  PRESS_AREA,
  ERROR,
  HOME,
  ICON,
  SHORTCUTS,
  MEDIA,
  MEDIA_THEMATIC,
  BRANCHES,
  FINANCIAL,
  CATEGORIES,
  TERRITORIES,
  THEMATICS,
  TYPES,
  AGENDA,
  FILTERS,
  EXPERTISES,
  INNOVATIONS,
  CONTACTS,
  SEARCH,
  RGPD,
  DATA_NOVA_MAP,
  PAGINATION,
  PUBLICATION,
  HUB_ACTUS,
};

export default {
  ...CAROUSEL,
  ...COMMON,
  ...GOUVERNANCE,
  ...HEADER,
  ...SOCIAL,
  ...FOOTER,
  ...PRESS_AREA,
  ...ERROR,
  ...HOME,
  ...ICON,
  ...SHORTCUTS,
  ...MEDIA,
  ...MEDIA_THEMATIC,
  ...BRANCHES,
  ...FINANCIAL,
  ...CATEGORIES,
  ...TERRITORIES,
  ...THEMATICS,
  ...TYPES,
  ...AGENDA,
  ...FILTERS,
  ...EXPERTISES,
  ...INNOVATIONS,
  ...CONTACTS,
  ...SEARCH,
  ...RGPD,
  ...DATA_NOVA_MAP,
  ...PAGINATION,
  ...PUBLICATION,
  ...HUB_ACTUS,
};
